import lodashDebounce from 'lodash/debounce'

/** @internal */
export const debounce = lodashDebounce
